import { Pipe, PipeTransform } from '@angular/core'

const padNum = (num: number) => (num + '').padStart(2, '0')
const padDay = (num: number) => (num + '').padStart(3, ' ')

@Pipe({
  name: 'duration'
})
export class DurationPipe implements PipeTransform {

  transform(mins: number, args?: any): any {
    const hours = Math.floor(mins / 60)
    const minutes = mins % 60
    return `${padNum(hours)}:${padNum(minutes)}`
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/time/duration.pipe.ts